module.exports = __webpack_public_path__ + "img/calendar-chevron-left.7f1183ca.svg";